import I18n from 'i18n-js';
import { Logger } from '@eyeson/js';
import React, { useState } from 'react';
import { Icon, IconButton, Tooltip } from '@material-ui/core';

const CopyMessageButton = ({ content, onEvent }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(content);
      setCopied(true);
      setTimeout(() => {
        try {
          if (document.activeElement.matches('.copy-button')) {
            document.activeElement.blur();
          }
        } catch (_err) {}
        setTimeout(() => setCopied(false), 200);
      }, 1800);
    } catch (error) {
      Logger.error('ChatMessage::handleCopy', error);
      onEvent({ type: 'warning', name: 'label:copy_error' });
    }
  };

  return (
    <Tooltip
      title={
        copied ? I18n.t('label:copied') : I18n.t('label:copy_to_clipboard')
      }
    >
      <span className="copy-button-wrap">
        <IconButton
          className="copy-button"
          onClick={handleCopy}
          aria-label={I18n.t('label:copy_to_clipboard', {
            defaultValue: 'Copy to clipboard',
          })}
        >
          <Icon fontSize="small">file_copy</Icon>
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default CopyMessageButton;
